export const LOGIN_POP_UP_SHOW = 'LOGIN_POPUP:SHOW';
export const LOGIN_POP_UP_CLOSE = 'LOGIN_POPUP:CLOSE';

export const showLoginPopUp = (data) => (dispatch) => {
    dispatch({
        type: LOGIN_POP_UP_SHOW,
        data,
    });
};

export const closeLoginPopUp = () => (dispatch) => {
    dispatch({
        type: LOGIN_POP_UP_CLOSE,
    });
};
